/* ============
 * The initial state of the patient module.
 * ============
 */
export default {
  isReminderListLoading: false,
  assessmentReminders: [],
  error: null,
  totalCount: 0
};
